import { DrivingExpirience } from "api"
import dynamic from "next/dynamic"
import { useState } from "react"
import styled from "styled-components"
import FeaturesWrapper from "./features/FeaturesWrapper"
import PerformanceWrapper from "./performance/PerformanceWrapper"

const PerformanceModal = dynamic(
  () => import("./performance/PerformanceModal"),
  { ssr: false }
)

const FeaturesPopup = dynamic(() => import("./features/FeaturesPopup"), {
  ssr: false,
})

const StyledSectionWrapper = styled.div`
  width: 100%;
  background: ${(p) => p.theme.colors.lightGrey};
  display: flex;
  align-items: center;
  flex-direction: column;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-top: 40px;
  }
`

type DrivingExperienceSectionType = {
  drivingExpirience: DrivingExpirience
  modelName: string
  modelImge: string
}

const DrivingExperienceSection = ({
  drivingExpirience,
  modelName,
  modelImge,
}: DrivingExperienceSectionType) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [featuresOpen, setFeaturesOpen] = useState(false)

  return (
    <StyledSectionWrapper>
      <PerformanceWrapper
        drivingExpirience={drivingExpirience}
        setModalOpen={setModalOpen}
      />
      {drivingExpirience?.displayComponents &&
        drivingExpirience?.displayComponents?.length > 0 && (
          <FeaturesWrapper
            data={drivingExpirience}
            openFeaturesModel={() => setFeaturesOpen(true)}
          />
        )}
      {modalOpen && (
        <PerformanceModal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          modelName={modelName}
          data={drivingExpirience}
          modelImge={modelImge}
        />
      )}
      {featuresOpen && (
        <FeaturesPopup
          open={featuresOpen}
          onClose={() => setFeaturesOpen(false)}
          modelName={modelName}
          data={drivingExpirience.moreInfoComponents}
        />
      )}
    </StyledSectionWrapper>
  )
}

export default DrivingExperienceSection
